import { useField } from 'formik'
import { Input } from 'almanac-ui/TextInputField/Input'
import { string } from 'yup'
import { isUrlCrawlable } from 'hooks/useIsUrlCrawlable'
import Styles from './BrandStyleExtractionWizard.module.scss'

export const validationSchema = string()
  .required()
  .transform((value) => {
    try {
      const url = new URL(value)
      return url.toString()
    } catch (e) {
      return `https://${value}`
    }
  })
  .test(
    'is-valid-url',
    // eslint-disable-next-line no-template-curly-in-string
    '${path} is not a valid url',
    (value) => isUrlCrawlable(value).isValid,
  )

export const UrlInput = () => {
  const [inputProps, metaProps] = useField('url')

  return (
    <div className={Styles.inputContainer}>
      <Input
        aria-label="website"
        autoFocus
        size="lg"
        autoComplete="off"
        {...inputProps}
        placeholder="Enter your website here (recommended)..."
        isValid={!metaProps.touched || !metaProps.error}
        errorMessage={metaProps.touched && metaProps.error}
      />
    </div>
  )
}
